import Vue from 'vue';

export const SearchApi = {
  getUserNames: async (ids) => {
    const response = await Vue.http.post("/api/contributor_names", {ids});
    return response.body;
  }
}